module.exports = __webpack_public_path__ + "img/aboutme.d6662b1c.jpg";